import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import AboutContentReducer from './AboutContentReducer';
import { aboutContentReducerKey } from './AboutContentConstants';
import AboutContent from './AboutContent';
import {
  isLoading as isLoadingSelector,
  BEBuildNumber as BEBuildNumberSelector,
  preparedDatabases as preparedDatabasesSelector,
  preparedUpdateInfo as preparedUpdateInfoInfoSelector,
} from './AboutContentSelectors';
import { init } from './AboutContentActions';
import { withCombinedRouteParams } from '../../AppRoutes/ConnectedRoute';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  BEBuildNumber: BEBuildNumberSelector(state),
  databases: preparedDatabasesSelector(state),
  updateInfo: preparedUpdateInfoInfoSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(init()),
});

const AboutContentContainer = compose(
  withCombinedRouteParams,
  withReducer(aboutContentReducerKey, AboutContentReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(AboutContent);

export default AboutContentContainer;
